import { Button, Screen, Text, TextInput } from "components"
import React, { useCallback, useEffect, useState } from "react"
import { Image, TouchableOpacity, View, useWindowDimensions } from "react-native"
import { style } from "./styles"
import { useFocusEffect, useNavigation, useRoute } from "@react-navigation/native"
import { translate } from "i18n"
import Icon from "@expo/vector-icons/MaterialIcons"
import MaterialCommunityIcons from "@expo/vector-icons/MaterialCommunityIcons"
import flash from "config/flash"
import { colors } from "colors"
import Modal from "react-native-modal"
import QRCode from "react-native-qrcode-svg"
import moment from "moment-timezone"
import { useSessionExpired } from "utils/function"
import { useStores } from "models"
import RenderHTML from "react-native-render-html"
import { useColor } from "app/theme/getThemes"
import { BarcodeComponent } from "components/Barcode"
import { typography } from "theme"

export const VoucherDetailScreen = () => {
  const navigation = useNavigation<any>()
  const { companyTheme } = useColor()

  const route = useRoute()
  const { routeFrom, item }: any = route?.params || {}
  const { height, width } = useWindowDimensions()
  const [user, setUser] = useState({})
  const [isTncOpen, setIsTncOpen] = useState(false)
  const [isRedeemOpen, setIsRedeemOpen] = useState(false)
  const [data] = useState(item)
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false)
  const { sessionExpired } = useSessionExpired()
  const { userStore } = useStores()
  const [point, setPoint] = useState(userStore?.totalPoint || 0)
  const [isUserUseVoucher, setIsUserUseVoucher] = useState(!!item?.use_at)
  const [countdown, setCountdown] = useState(-1)
  const [isVoucherExpired, setIsVoucherExpired] = useState(
    item?.use_at
      ? moment().tz("Asia_Kuala_Lumpur").isAfter(moment(item?.use_at)?.add("m", 15))
      : false,
  )
  const [pickPlatformModal, setPickPlatformModal] = useState(false)
  const [platform, setPlatform] = useState([
    { name: "Tiktok" },
    { name: "Lazada" },
    { name: "Shopee" },
  ])
  const [selectedPlatform, setSelectedPlatform] = useState(null)
  const [userDetails, setUserDetails] = useState(false)

  const [voucherRequiredPoint, setVoucherRequiredPoint] = useState(item?.voucher_point_required)
  const oldBalance = userStore?.totalPoint || 0
  const newBalance = oldBalance - voucherRequiredPoint
  const [balanceChange, setBalanceChange] = useState({ old: oldBalance, new: newBalance })

  // wh
  {
    /* Task 1 : Create a state for number plate handling and also number plate modal handling */
  }
  const [isCarParkVoucher, setIsCarParkVoucher] = useState(false)
  const [carPlate, setCarPlate] = useState("")
  const [carPlateError, setCarPlateError] = useState(null)
  const [codeType, setCodeType] = useState("qr")

  useFocusEffect(
    useCallback(() => {
      getMemberProfile()
    }, []),
  )

  useEffect(() => {
    routeFrom === "voucherFrom" && getUserPoint()
  }, [])

  useEffect(() => {
    if (isUserUseVoucher && item?.use_at) {
      const expirationTime = moment(item?.use_at).add(15, "minutes")
      const countdownSeconds = expirationTime.diff(moment(), "seconds")
      setCountdown(countdownSeconds)
    }
  }, [isUserUseVoucher, item?.use_at])

  useEffect(() => {
    let timer

    if (countdown > 0) {
      timer = setInterval(() => {
        setCountdown((prev) => prev - 1)
      }, 1000)
    } else if (countdown === 0) {
      onCloseModal()
      setIsVoucherExpired(true)
      navigation.goBack()
    }

    return () => clearInterval(timer)
  }, [countdown])

  const formatCountdown = () => {
    const minutes = Math.floor(countdown / 60)
    const seconds = countdown % 60
    return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`
  }

  const onCloseModal = () => {
    setIsModalVisible(false)
    setPickPlatformModal(false)
    setUserDetails(false)
    setIsCarParkVoucher(false) // wh
  }

  const getUserPoint = async () => {
    await fetch(`${process.env.API_URL}/api/client/pointbal`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userStore?.accessToken}`,
      },
    })
      .then(async (res) => {
        if (res?.ok) {
          const responseData = await res?.json()
          setPoint(responseData?.data)
          userStore?.update({
            totalPoint: responseData?.data,
          })
        } else {
          const errorMsg = await res?.json()
          if (errorMsg?.error === "Token expired" || errorMsg?.error === "Invalid token") {
            sessionExpired()
          }
        }
      })
      .catch((e) => {
        console.error(e)
      })
  }

  const redeemVoucher = async () => {
    await fetch(`${process.env.API_URL}/api/voucher_list/redeem`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userStore?.accessToken}`,
      },
      body: JSON.stringify({
        voucher_id: data?.voucher_catalog_id,
        member_id: userStore?.id,
      }),
    })
      .then(async (res) => {
        if (res?.ok) {
          userStore?.update({
            totalPoint: newBalance,
          })

          onCloseModal()
          navigation.goBack()
          flash("success", translate("voucherDetailScreen.redeemSuccesfully"))
        } else {
          onCloseModal()

          const errorMsg = await res?.json()

          if (errorMsg?.message === "Token expired" || errorMsg?.message === "Invalid token") {
            sessionExpired()
          } else if (errorMsg?.message === "Error redeem voucher. No stock is available.") {
            flash("error", translate("errors.outOfStock"))
          } else if (
            errorMsg?.message === "Error redeem voucher. Balance is not enough to redeem."
          ) {
            flash("error", translate("errors.notEnoughPoint"))
          } else {
            flash("error", translate("errors.failedToRedeemNoVoucher"))
          }
        }
      })
      .catch((e) => {
        flash("error", translate("errors.failedToRedeemNoVoucher"))
        console.error(e)
      })
  }

  const getMemberProfile = async () => {
    await fetch(`${process.env.API_URL}/api/client/profile`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userStore?.accessToken}`,
      },
    })
      .then(async (res) => {
        if (res?.ok) {
          const responseData = await res?.json()

          // console.log("Member details =>", responseData?.data)
          setUser(responseData?.data)
        } else {
          const errorMsg = await res?.json()
          if (errorMsg?.error === "Token expired" || errorMsg?.error === "Invalid token") {
            sessionExpired()
          } else {
            flash("error", translate("errors.failedToRetreiveMember"))
          }
        }
      })
      .catch((e) => {
        flash("error", translate("errors.failedToRetreiveMember"))
        console.error(e)
      })
  }

  const userUserVoucher = async () => {
    if (user && (!user.dob || !user.gender || !user.race || !user.contact_number)) {
      setUserDetails(true)
      // console.log("User details not full", user)
    } else {
      await fetch(`${process.env.API_URL}/api/voucher_list/redeem`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `bearer ${userStore?.accessToken}`,
        },
        body: JSON.stringify({
          voucher_id: data?.voucher_catalog_id,
          voucher_barcode: item?.voucher_barcode,
          redeem_by: userStore?.id,
        }),
      })
        .then(async (res) => {
          if (res?.ok) {
            setCountdown(900)
            setIsUserUseVoucher(true)
          } else {
            const errorMsg = await res?.json()
            if (errorMsg?.error === "Token expired" || errorMsg?.error === "Invalid token") {
              sessionExpired()
            } else {
              onCloseModal()
              flash("error", translate("errors.failedToUseVoucher"))
            }
          }
        })
        .catch((e) => {
          onCloseModal()
          flash("error", translate("errors.failedToUseVoucher"))
          console.error(e)
        })
    }
  }

  const Accordion = ({ type, text }: { type: "redeem" | "tnc"; text: string }) => {
    const openAccordion = type === "redeem" ? isRedeemOpen : isTncOpen
    const setOpenAccordion = type === "redeem" ? setIsRedeemOpen : setIsTncOpen

    const regex = /<[^>]*>/gim
    const filteredText = text?.replace(regex, "")

    return (
      <View style={style.accordionContainer}>
        <TouchableOpacity
          onPress={() => {
            setOpenAccordion(!openAccordion)
          }}
          style={style.accordionTitleContainer}
        >
          <Text>
            {type === "redeem"
              ? translate("voucherDetailScreen.howToUse")
              : translate("promotionDetailScreen.tnc")}
          </Text>
          {openAccordion ? (
            <MaterialCommunityIcons name="chevron-up" size={24} color={companyTheme.first} />
          ) : (
            <MaterialCommunityIcons name="chevron-down" size={24} color={companyTheme.first} />
          )}
        </TouchableOpacity>
        {openAccordion && (
          <View>
            <View style={style.accordionContentContainer} />
            <Text>{filteredText}</Text>
          </View>
        )}
      </View>
    )
  }

  // wh
  /* Task 4 : Create a console.log for parking number have entrered */
  const handleCarPlate = () => {
    if (!carPlate.trim()) {
      setCarPlateError("Vehicle plate number is required")
      return // Stop execution if there's an error
    }

    // if (!isValidCarPlate(carPlate)) {
    //   setCarPlateError("Invalid vehicle plate number format");
    //   return; // Stop execution if there's an error
    // }

    // If there are no errors:
    // console.log("Car plate entered:", carPlate)
    if (isUserUseVoucher && routeFrom !== "voucherHistory") {
      navigation.goBack()
      flash("success", translate("voucherDetailScreen.useVoucherSuccessfully"))
    }
    onCloseModal() // Only close the modal if there are no errors
  }

  return (
    <>
      <Screen preset="scroll" contentContainerStyle={style.scrollContent}>
        <View>
          <View
            style={{
              height: width * 0.6,
              maxHeight: height * 0.4,
              backgroundColor: companyTheme.second,
            }}
          >
            <Image
              source={{
                uri: data?.voucher_image,
              }}
              style={[style.image, { height: "100%", width: "100%", resizeMode: "contain" }]}
            />
            <TouchableOpacity onPress={() => navigation.goBack()} style={style.headerLeftButton}>
              <Icon name="arrow-back" size={28} color="white" />
            </TouchableOpacity>
          </View>
          <View style={style.container}>
            <Text style={style.title}>{data?.voucher_name}</Text>

            {item?.start_date && item?.end_date ? (
              <View style={style.calendarContainer}>
                <MaterialCommunityIcons
                  name="calendar-month"
                  size={28}
                  color={companyTheme.first}
                />
                {!item?.voucher_barcode ? (
                  <Text style={style.dateText}>
                    {moment(item?.start_date).format("DD-MMM-YYYY")} -{" "}
                    {moment(item?.end_date).format("DD-MMM-YYYY")}
                  </Text>
                ) : (
                  <Text style={style.dateText}>
                    Expires at : {moment(item?.voucher_expire_at).format("DD-MMM-YYYY")}
                  </Text>
                )}
              </View>
            ) : (
              <View style={style.calendarContainer}>
                <MaterialCommunityIcons
                  name="calendar-month"
                  size={28}
                  color={companyTheme.first}
                />

                <Text style={style.dateText}>
                  {translate("voucherScreen.expiredOn")} -{" "}
                  {moment(item?.voucher_expired_at).format("DD-MM-YYYY")}
                </Text>
              </View>
            )}

            <View
              style={{
                width: "100%",
                justifyContent: "space-between",
                display: "flex",
                flexDirection: "row",
              }}
            >
              {/* <Text style={style.description}>
                {item?.voucher_description?.replace(/<[^>]*>/gim, "")}
              </Text> */}
              <View style={{ width: `${item?.voucher_point_required ? "80%" : "100%"}` }}>
                <RenderHTML
                  source={{ html: item?.voucher_description || "" }}
                  baseStyle={style.description}
                />
              </View>
            </View>

            {item?.voucher_point_required > 0 && !item?.voucher_barcode && (
              <Text style={[style.description, { color: colors.buttonBackground, marginTop: 0 }]}>
                {item?.voucher_point_required} pts
              </Text>
            )}

            {/* Accordian dropdown */}
            <Accordion type="redeem" text={item?.voucher_how_to_redeem} />
            <Accordion type="tnc" text={item?.voucher_tnc} />
          </View>
          {/* Sticky bottom */}
        </View>
      </Screen>

      <View
        style={[
          style.stickyBottomContainer,
          routeFrom === "voucherHistory"
            ? !isVoucherExpired
              ? {}
              : {
                  backgroundColor: colors.background,
                }
            : {},
        ]}
      >
        {routeFrom === "voucherHistory" || isVoucherExpired ? (
          !isVoucherExpired ? (
            <Button
              onPress={() => {
                setIsModalVisible(true)
              }}
              title={translate("voucherDetailScreen.useVoucher")}
              style={style.buttonContainer}
              titleStyle={style.buttonText}
            />
          ) : (
            <Text style={style.usedExpiredText}>
              {item?.use_at
                ? translate("voucherDetailScreen.usedOn")
                : translate("voucherDetailScreen.expiredOn")}{" "}
              {moment(item?.use_at ? item?.use_at : item?.end_date).format("DD-MM-YYYY • hh:mm")}
            </Text>
          )
        ) : (
          <>
            {routeFrom !== "redeemVoucher" && (
              <Text style={style.dontClickText}>
                {translate("voucherDetailScreen.dontClickVoucher")}
              </Text>
            )}
            <Button
              onPress={() => {
                if (point < item?.voucher_point_required && routeFrom === "redeemVoucher") {
                  flash("error", "Not enough points to redeem")
                } else {
                  setIsModalVisible(true)
                }
              }}
              title={
                routeFrom === "redeemVoucher"
                  ? translate("voucherDetailScreen.redeem")
                  : translate("voucherDetailScreen.useVoucher")
              }
              style={style.buttonContainer}
              titleStyle={style.buttonText}
            />
          </>
        )}
      </View>

      {/* Modal */}
      <Modal
        isVisible={isModalVisible}
        onBackdropPress={() => {
          if (isUserUseVoucher && routeFrom !== "voucherHistory") {
            navigation.goBack()
            flash("success", translate("voucherDetailScreen.useVoucherSuccessfully"))
            onCloseModal()
          } else {
            onCloseModal()
          }
        }}
        onBackButtonPress={() => {
          if (isUserUseVoucher && routeFrom !== "voucherHistory") {
            navigation.goBack()
            flash("success", translate("voucherDetailScreen.useVoucherSuccessfully"))
            onCloseModal()
          } else {
            onCloseModal()
          }
        }}
      >
        <View
          style={[
            style.modalContainer,
            data?.voucher_type === "brand_voucher" && { backgroundColor: companyTheme.second },
          ]}
        >
          {data?.voucher_type === "brand_voucher" && (
            <Text
              style={{
                fontSize: 30,
                fontFamily: typography.primary.normal,
                fontWeight: "bold",
                marginBottom: 20,
                color: colors.white,
              }}
            >
              LARRIE Voucher
            </Text>
          )}
          {!isUserUseVoucher ? (
            <>
              <Text>
                {routeFrom === "myVoucher"
                  ? translate("voucherDetailScreen.areYouSureUse")
                  : translate("voucherDetailScreen.areYouSureRedeem")}
              </Text>

              {voucherRequiredPoint > 0 && (
                <View style={style.oldNewBalContainer}>
                  <View style={style.balanceRow}>
                    <Text style={style.balanceLabelOld}>Old Balance:</Text>
                    <Text style={style.balanceValueOld}>{balanceChange.old}</Text>
                  </View>

                  <View style={style.balanceRow}>
                    <Text style={style.balanceLabelNew}>New Balance:</Text>
                    <Text style={style.balanceValueNew}>{balanceChange.new}</Text>
                  </View>
                </View>
              )}

              <View style={style.redeemModalContainer}>
                <Button
                  onPress={() => onCloseModal()}
                  title={
                    routeFrom === "myVoucher"
                      ? translate("voucherDetailScreen.useLater")
                      : translate("voucherDetailScreen.redeemLater")
                  }
                  style={[style.redeemLaterButton, { borderColor: companyTheme.first }]}
                  titleStyle={{
                    color: companyTheme.first,
                  }}
                />
                <Button
                  onPress={() => {
                    routeFrom === "myVoucher" ? userUserVoucher() : redeemVoucher()
                  }}
                  title={
                    routeFrom === "myVoucher"
                      ? translate("voucherDetailScreen.use")
                      : translate("voucherDetailScreen.redeem")
                  }
                  style={style.flex}
                />
              </View>
            </>
          ) : (
            <>
              <TouchableOpacity onPress={() => setCodeType(codeType === "qr" ? "barcode" : "qr")}>
                {codeType === "qr" ? (
                  <QRCode
                    size={150}
                    value={`${item?.voucher_catalog_id}-${item?.voucher_barcode}`}
                  />
                ) : (
                  <>
                    <BarcodeComponent
                      format="CODE128"
                      value={`${item?.voucher_catalog_id}-${item?.voucher_barcode}`}
                      width={1}
                    />
                  </>
                )}
                {codeType === "qr" && (
                  <Text
                    style={{ alignSelf: "center", marginTop: 10 }}
                  >{`${item?.voucher_catalog_id}-${item?.voucher_barcode}`}</Text>
                )}
              </TouchableOpacity>
              <Text style={style.qrExpiredText}>
                {translate("voucherDetailScreen.clickToShowBarCode")} {codeType}
              </Text>

              {/* <View
                style={{
                  marginTop: 10,
                  width: "100%",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <BarcodeComponent
                  format="CODE128"
                  value={`${item?.voucher_catalog_id}-${item?.voucher_barcode}`}
                  width={2}
                />
              </View> */}
              <View style={style.dividerView}>
                <View style={style.dividerViewStyle} />
              </View>
              <Text style={style.qrText}>{translate("voucherDetailScreen.enjoyDeals")}</Text>
              <Text style={style.qrExpiredText}>
                {translate("voucherDetailScreen.expiredIn")}{" "}
                <Text
                  style={{
                    color:
                      data?.voucher_type === "brand_voucher" ? colors.white : companyTheme.second,
                  }}
                >
                  {formatCountdown()}
                </Text>
              </Text>
              {/* <View style={style.dividerView}>
                <View style={style.dividerViewStyle} />
              </View>

              <Text style={style.qrExpiredText}>
                You Still Have
                <Text style={{ color: companyTheme.first }}>(8/9)</Text>
                Voucher Remainning
              </Text> */}
              <Button
                onPress={() => {
                  if (isUserUseVoucher && routeFrom !== "voucherHistory") {
                    navigation.goBack()
                    flash("success", translate("voucherDetailScreen.useVoucherSuccessfully"))
                    onCloseModal()
                  } else {
                    onCloseModal()
                  }
                }}
                style={style.mt30}
                title={translate("common.confirm")}
              />
            </>
          )}
        </View>
      </Modal>

      {/* Pick platform */}
      <Modal
        isVisible={pickPlatformModal}
        onBackdropPress={() => {
          if (isUserUseVoucher && routeFrom !== "voucherHistory") {
            navigation.goBack()
            flash("success", translate("voucherDetailScreen.useVoucherSuccessfully"))
            onCloseModal()
          } else {
            onCloseModal()
          }
        }}
        onBackButtonPress={() => {
          if (isUserUseVoucher && routeFrom !== "voucherHistory") {
            navigation.goBack()
            flash("success", translate("voucherDetailScreen.useVoucherSuccessfully"))
            onCloseModal()
          } else {
            onCloseModal()
          }
        }}
      >
        <View style={[style.modalContainer, { width: "50%" }]}>
          <>
            <Text style={{ fontSize: 30, marginBottom: 20, fontWeight: "bold" }}>
              {translate("voucherDetailScreen.pickPlatform")}
            </Text>

            <View
              style={{ display: "flex", flexWrap: "nowrap", flexDirection: "column", width: "50%" }}
            >
              {platform.map((a: any) => (
                <TouchableOpacity
                  key={a?.name}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center",
                    height: 50,
                    width: "100%",
                    borderRadius: 15,
                    borderWidth: 1,
                    borderColor: selectedPlatform === a?.name ? "green" : "grey",
                    paddingVertical: 10,
                    backgroundColor: selectedPlatform === a?.name ? "#00B69B1F" : "#fff", // Add a subtle background color for selected state
                    marginBottom: 10, // Add space between buttons
                    shadowColor: "#000", // Add shadow for depth
                    shadowOffset: { width: 0, height: 2 }, // Shadow offset
                    shadowOpacity: 0.1, // Shadow opacity
                    shadowRadius: 3, // Shadow radius
                    elevation: 1, // Elevation for Android
                  }}
                  onPress={() => setSelectedPlatform(a?.name)}
                >
                  <Text
                    style={{
                      paddingHorizontal: 20,
                      fontSize: 16,
                      fontWeight: "bold",
                      color: selectedPlatform === a?.name ? "green" : "#000",
                    }}
                  >
                    {a.name}
                  </Text>
                  {selectedPlatform === a?.name && <Icon name="thumb-up" size={15} color="green" />}
                </TouchableOpacity>
              ))}
            </View>

            <Button
              onPress={() => {
                if (isUserUseVoucher && routeFrom !== "voucherHistory") {
                  navigation.goBack()
                  flash("success", translate("voucherDetailScreen.useVoucherSuccessfully"))
                  onCloseModal()
                } else {
                  onCloseModal()
                }
              }}
              style={style.mt30}
              title={translate("common.confirm")}
            />
          </>
        </View>
      </Modal>

      {/* userDetails */}
      <Modal
        isVisible={userDetails}
        onBackdropPress={() => onCloseModal()}
        onBackButtonPress={() => onCloseModal()}
      >
        <View style={style.modalContainer}>
          <>
            <Text style={{ textAlign: "center" }}>
              Seems your profile not complete yet , please complete your profile first
            </Text>
            <View style={style.redeemModalContainer}>
              <Button
                onPress={() => onCloseModal()}
                title={"Later"}
                style={[style.redeemLaterButton, { borderColor: companyTheme.first }]}
                titleStyle={{
                  color: companyTheme.first,
                }}
              />
              <Button
                onPress={() => {
                  navigation.navigate("editProfile")
                  onCloseModal()
                }}
                title={"Edit Now"}
                style={style.flex}
              />
            </View>
          </>
        </View>
      </Modal>

      {/* Task 2 : Create a Modal for parking purpose */}
      <Modal
        isVisible={isCarParkVoucher}
        onBackdropPress={() => onCloseModal()}
        onBackButtonPress={() => onCloseModal()}
      >
        <View style={style.modalContainer}>
          <>
            <Text style={{ width: "100%", textAlign: "center", marginBottom: 15 }}>
              Enter your vehicle plate number
            </Text>

            <TextInput
              value={carPlate}
              onChangeText={(text) => {
                // 1. Remove special characters
                const sanitizedText = text.replace(/[^a-zA-Z0-9\s]/g, "")
                // 2. Convert to uppercase
                const upperCaseText = sanitizedText.toUpperCase()
                // 3. Update the state
                setCarPlate(upperCaseText)

                // 4. Validation and Error Message
                if (!upperCaseText.trim()) {
                  setCarPlateError("Vehicle plate number is required")
                  // } else if (!isValidCarPlate(upperCaseText)) {
                  //   setCarPlateError("Invalid vehicle plate number format");
                } else {
                  setCarPlateError(null) // Clear error
                }
              }}
              placeholder="ABC 1234"
            />

            <View style={[style.errorContainer, { width: "100%" }]}>
              {carPlateError && (
                // Conditionally render the content *inside* the container
                <>
                  <Icon name="error" size={16} color="red" style={style.errorIcon} />
                  <Text style={style.errorText}>{carPlateError}</Text>
                </>
              )}
            </View>

            <View style={[style.redeemModalContainer, { width: "100%" }]}>
              <Button
                onPress={() => onCloseModal()}
                title={"Later"}
                style={[style.redeemLaterButton]}
                titleStyle={{
                  color: companyTheme.first,
                }}
              />
              <Button
                onPress={() => {
                  handleCarPlate()
                }}
                title={"Confirm"}
                style={style.flex}
                titleStyle={{
                  color: colors.white,
                }}
              />
            </View>
          </>
        </View>
      </Modal>
    </>
  )
}
